import { render } from "./CreateDocument.vue?vue&type=template&id=a300fec4"
import script from "./CreateDocument.vue?vue&type=script&lang=js"
export * from "./CreateDocument.vue?vue&type=script&lang=js"
script.render = render

export default script